import React from 'react';
import css from '../EditListingDescriptionForm.css';
import CustomFormField from '../../CustomFormField/CustomFormField';
import { skills as skillsOptions } from '../../../marketplace-custom-config';

const EditListingDescriptionPageEight = props => (
    <div>
        <h1 className={css.horseTypeTitle}>Besondere Anforderungen</h1>
        <p className={css.horseTypeSubTitle}>Erzähle uns, was dir sonst noch wichtig ist.</p>
        <div className={css.marginWrapper}>
            <CustomFormField
                fieldName="skills"
                nonCustomOptions={skillsOptions}
                options={skillsOptions}
                customFieldPlaceholderId="EditListingDescriptionForm.permittedActivitiesAddCustomOption"
                {...props}
            />
        </div>
    </div>
);

export default EditListingDescriptionPageEight;
